import * as types from '../../actions/types'

const initialState = {
    contactWindowState: 0,
    contactModalBlink: null,
    contacts: null,
    contactModals: [], //including hidden
    contactModalsHidden: []
}

export function contactReducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.CONTACT_SET_MY_ID:
            return state;
        case types.CONTACT_WINDOW_MAXIMIZE:
            return Object.assign({}, state, { contactWindowState: 0 })
        case types.CONTACT_WINDOW_MINIMIZE:
            return Object.assign({}, state, { contactWindowState: 1 })
        case types.CONTACT_MODAL_BLINK:
            return Object.assign({}, state, { contactModalBlink: action.payload })
        case types.CONTACTS_GET:
            return Object.assign({}, state, { contacts: action.contacts })
        case types.CONTACT_MODAL_OPEN:
            if (state.contactModals.includes(action.payload)) {
                return state;
            } else {
                return Object.assign({}, state, {
                    contactModals: [action.payload, ...state.contactModals.filter(el => {
                        return el !== action.payload
                    })]
                })
            }
        case types.CONTACT_MODAL_CLOSE:
            return Object.assign({}, state, {
                contactModals: [...state.contactModals.filter(el => {return el !== action.payload})],
                contactModalsHidden: [...state.contactModalsHidden.filter(el => {return el !== action.payload})]
            })
        case types.CONTACT_MODAL_HIDE:
            if (state.contactModalsHidden.includes(action.payload)) {
                return state;
            } else {
                return Object.assign({}, state, {
                    contactModalsHidden: [action.payload, ...state.contactModalsHidden.filter(el => {
                        return el !== action.payload
                    })]
                })
            }
        case types.CONTACT_MODAL_UNHIDE:
            if (!state.contactModalsHidden.includes(action.payload)) {
                return state;
            } else {
                return Object.assign({}, state, {
                    contactModalsHidden: [...state.contactModalsHidden.filter(el => {
                        return el !== action.payload
                    })]
                })
            }

        case types.CONTACT_SWITCH_TO_HIDDEN:
            if (!state.contactModalsHidden.includes(action.payload) || state.contactModals.length < 2) {
                return state;
            } else {
                let contactsVisible = state.contactModals.filter(el => { return !state.contactModalsHidden.includes(el)});
                if (contactsVisible.length < 1) return state; //no window found to swap with
                let index1 = state.contactModals.findIndex(el => { return el === action.payload});
                let index2 = state.contactModals.findIndex(el => { return el === contactsVisible[contactsVisible.length - 1]});
                let contactModalsNew = [...state.contactModals];
                let el = contactModalsNew[index1];
                contactModalsNew[index1] = contactModalsNew[index2];
                contactModalsNew[index2] = el;

                return Object.assign({}, state, {
                    contactModals: contactModalsNew,
                    contactModalsHidden: [contactsVisible[contactsVisible.length - 1], ...state.contactModalsHidden.filter(el => {
                        return el !== action.payload
                    })]
                })
            }


        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/chat/contactReducer.js